class ProductStickyAtc extends Theme.Component {
  #observer = null;

  connectedCallback() {
    this.submitButton = document.querySelector('.product-info [data-product-submit-button]');
    if (!this.submitButton) return;

    this.form = this.submitButton.closest('form');
    super.connectedCallback();

    this.#observer = new IntersectionObserver(([entry]) => this.toggle(!entry.isIntersecting));

    this.#observer.observe(this.submitButton);
  }

  disconnectedCallback() {

    super.disconnectedCallback();
    if (this.#observer) this.#observer.disconnect();
  }

  toggle(isActive) {
    this.classList.toggle('state--active', isActive);
    this.setAttribute('aria-hidden', String(!isActive));
    this.querySelector('button').tabIndex = isActive ? 0 : -1;
  }

  scrollToForm() {
    const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--fixed-header-height')) || 0;
    const top = this.form.getBoundingClientRect().top + window.scrollY - headerHeight;

    window.scrollTo({ top, behavior: 'smooth' });
  }
}

customElements.define('product-sticky-atc', ProductStickyAtc);
